import { useEffect, useRef, useState } from "react";
import { FallbackProps } from "react-error-boundary";
import PageWrapper from "./PageWrapper";
import { Link } from "react-router-dom";

const ErrorBoundaryFallback = ({error, resetErrorBoundary}: FallbackProps) => {

  const [timer, setTimer] = useState(4);
  const timerRef = useRef<NodeJS.Timer>(null);

  useEffect(() => {
    timerRef.current = setInterval(() => {
      if (timer === 0 && timerRef.current) clearInterval(timerRef.current);
      setTimer(prev => prev - 1);
    }, 1000);

    return () => {
      timerRef.current && clearInterval(timerRef.current);
    }
  }, []);

  return (
    <PageWrapper>
      <div className='item-list large-gap'>
        <p className="heading-small center">Something went wrong</p>
        <div className='item-row center-horizontal'>
          <button
            className='primary'
            onClick={resetErrorBoundary}
            aria-disabled={timer>0}
          >
            {`Retry${timer>0 ? ` in ${timer}` : ''}`}
          </button>
          <Link to={'/'}>
            <button className='subtle'>Back</button>
          </Link>
        </div>
      </div>
    </PageWrapper>
  )
}
export default ErrorBoundaryFallback;